import { getExternalApi, ed, dbValue, clearDb } from 'app-core/data';
import MsSpeechToTextProvider from './msSpeechToTextProvider';
import MsTextToSpeechProvider from './msTextToSpeechProvider';
import DeepgramSpeechProvider from './deepgramProvider';

async function textToSpeech(text, opts) {
	const provider = (await getTextToSpeechProvider())?.Instance;
	return provider?.textToSpeech && provider.textToSpeech(text, opts);
}

async function startMicRecognition(callback, once) {
	const provider = (await getSpeechProvider())?.Instance;
	return provider?.startMicRecognition && provider.startMicRecognition(callback, once);
}

async function stopMicRecognition() {
	const provider = (await getSpeechProvider())?.Instance;
	return provider?.stopMicRecognition && provider.stopMicRecognition();
}

let speechProfilePromise = null;
async function getSpeechProvider() {	
	if (!speechProfilePromise) {
		speechProfilePromise = getExternalApi('SpeechProcessingProfile/Get', 'code=Posweb').then(async r => {
			if (r?.SpeechToTextProvider?.Config) {
				r.SpeechToTextProvider.DConfig = ed().d(r?.SpeechToTextProvider?.Config);
			}

			const DConfig = JSON.parse(r?.SpeechToTextProvider?.Config && ed().d(r?.SpeechToTextProvider?.Config) || '{}');
			const type = DConfig?.DeepgramApiKey ? 'deepgram' : 'msstt';
			const instance = type === 'deepgram' ? new DeepgramSpeechProvider() : new MsSpeechToTextProvider();
			if (instance.init) {
				await instance.init(DConfig);
			}

			if (__DEBUG__)
				console.debug('Init', { instance })

			return {
				...(r?.SpeechToTextProvider || {}),
				DConfig: DConfig,
				Type: type,
				Instance: instance
			}
		});
	}
	return speechProfilePromise;
}

let ttsProviderPromise = null;
async function getTextToSpeechProvider() {
	if (!ttsProviderPromise) {
		ttsProviderPromise = await {
			Instance: new MsTextToSpeechProvider()
		};
	}
	return ttsProviderPromise;
	
}

export default {
	startMicRecognition,
	stopMicRecognition,
	textToSpeech,
	dbValue,
	clearDb,
	getSpeechProvider,
	getTextToSpeechProvider
}

export {
	startMicRecognition,
	stopMicRecognition,
	textToSpeech,
	dbValue,
	clearDb,
	getSpeechProvider,
	getTextToSpeechProvider
}